import { render, staticRenderFns } from "./NestedDraggable.vue?vue&type=template&id=483b670d&scoped=true&"
import script from "./NestedDraggable.vue?vue&type=script&lang=js&"
export * from "./NestedDraggable.vue?vue&type=script&lang=js&"
import style0 from "./NestedDraggable.vue?vue&type=style&index=0&id=483b670d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483b670d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VChip,VCol,VRow})
